import React from 'react';

import { LockFilled } from '@ant-design/icons';

import {
  CardAvatar,
  CardHeader,
  CardProgress,
  VerticalSpace,
} from '@brokerbay/design-components';

import {
  OnboardingSetPasswordForm,
  OnboardingSetPasswordFormValue,
} from '../../components';

export type SetPasswordViewProps = {
  handleGoBackStep: () => void;
  handleSubmit: (values: OnboardingSetPasswordFormValue) => void;
};

export const SetPasswordView = (props: SetPasswordViewProps) => {
  const { handleGoBackStep, handleSubmit } = props;

  return (
    <VerticalSpace>
      <CardHeader
        title="Set Your Password"
        icon={<CardAvatar icon={LockFilled} />}
        onRequestStepBack={handleGoBackStep}
      />

      <OnboardingSetPasswordForm onSubmit={handleSubmit} />

      <CardProgress percent={(3 / 5) * 100} />
    </VerticalSpace>
  );
};
